import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const HeartIcon = ({
  title = 'Heart',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path fill="#fff" fillOpacity=".01" d="M0 0h24v24H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.841 3.111C4.263.528 8.168.493 10.63 3.006l.1.105L12 4.465l1.27-1.354c2.388-2.547 6.22-2.616 8.686-.208l.103.103.1.105c2.422 2.583 2.454 6.748.098 9.374l-.098.107-9.524 10.157a.858.858 0 0 1-1.22.049l-.05-.049-9.524-10.157c-2.454-2.618-2.454-6.863 0-9.481Zm1.905 2.031c-1.376 1.468-1.402 3.83-.078 5.332l.078.086L12 19.363l8.254-8.803c1.377-1.468 1.403-3.83.098-5.311l-.077-.085-.079-.082c-1.38-1.41-3.554-1.413-4.94-.023l-.081.084-3.176 3.385-3.173-3.386c-1.403-1.496-3.677-1.496-5.08 0Z"
    />
  </CreateIconComponent>
);

export default HeartIcon;
